import React, { type ReactNode } from 'react';
import { ErrorHandlerProvider } from '@library/providers/ErrorHandlerProvider';
import { ApiClientProvider } from '@library/providers/ApiClientProvider';
import type { ApiConfig, ErrorContext } from '@library/types';

// Two layers, where busLineSrv has four:
//   ErrorHandler → ApiClient reads it to turn thrown errors into ApiResponse
//   ApiClient    → the only thing on this site that talks to the API
//
// No StorageProvider and no AuthProvider. Nobody signs in here — the site makes
// exactly two API calls, POST /user/verifyemail and POST /user/newpassword, both
// authenticated by a uuid in the URL rather than by a session. The language and
// theme choices are the only things persisted, and each writes its own
// localStorage key directly.
//
// Deep-import each library provider by path. The `@library/providers` barrel
// re-exports the React Native AuthProvider/StorageProvider and
// would drag react-native into the bundle.

interface AllProvidersProps {
    children: ReactNode;
    apiConfig: ApiConfig;
    onError?: (error: Error, context: ErrorContext) => void;
}

export const AllProviders: React.FC<AllProvidersProps> = ({ children, apiConfig, onError }) => (
    <ErrorHandlerProvider onError={onError}>
        <ApiClientProvider config={apiConfig}>
            {children}
        </ApiClientProvider>
    </ErrorHandlerProvider>
);
